import { useCallback } from "react";
import { useToken } from "@rentablo/api";
import { goToSessionLogout } from "@helpers/mainAppUrls";
import { clearRecentlyViewedUsers } from "@features/admin/userManagement/hooks/useRecentlyViewedUsers";

export const useLogout = () => {
  const { logout: tokenLogout } = useToken({ enabled: false });
  const logout = useCallback(() => {
    tokenLogout();
    // Don't retain admin-viewed user PII after logout (shared-browser case).
    clearRecentlyViewedUsers();
    if (import.meta.env.VITE_APP_NAME === "rentablo") {
      goToSessionLogout();
    } else {
      window.location.href = import.meta.env.VITE_APP_ROOT_URL!;
    }
  }, [tokenLogout]);

  return {
    logout,
  };
};
